import { useState } from 'react';
import { useProjectContext } from '@/project/ProjectContext';
import { ProjectGate } from '@/features/projects/ProjectGate';
import { ProjectWorkspaceHeader } from '@/features/projects/ProjectWorkspaceHeader';
import { AutomationsFlagGate } from '@/features/automations/AutomationsFlagGate';
import { AutomationsWorkspace } from '@/features/automations/AutomationsWorkspace';
import { AgentsPanel } from '@/features/automations/AgentsPanel';
import { AutomationReportsPanel } from '@/features/automations/AutomationReportsPanel';
import { EnrollPoliciesPanel } from '@/features/enrollPolicies/EnrollPoliciesPanel';
import { StateMessage } from '@/components/StateMessage/StateMessage';
import autoStyles from '@/features/automations/automations.module.css';
import styles from './ProjectsPage.module.css';

type HubTab = 'workflows' | 'agents' | 'reports' | 'policies';

export function AutomationsPage() {
  const { selectedProject, setSelectedProjectId } = useProjectContext();
  const projectId = selectedProject?.id;
  const [tab, setTab] = useState<HubTab>('workflows');

  return (
    <ProjectGate>
      <AutomationsFlagGate>
        <div className={styles.page}>
          {!projectId ? (
            <StateMessage title="Kies een project" />
          ) : (
            <>
              <ProjectWorkspaceHeader
                title="Automations"
                subtitle="Event-workflows, AI-agents, concept-antwoorden (HITL) en automation reports."
                projectName={selectedProject?.name ?? ''}
                onSwitchProject={() => setSelectedProjectId(null)}
              />

              <div className={autoStyles.tabRow}>
                {(
                  [
                    ['workflows', 'Workflows'],
                    ['agents', 'Agents'],
                    ['reports', 'Reports'],
                    ['policies', 'Enroll policies'],
                  ] as const
                ).map(([id, label]) => (
                  <button
                    key={id}
                    type="button"
                    className={tab === id ? autoStyles.tabActive : autoStyles.tab}
                    onClick={() => setTab(id)}
                  >
                    {label}
                  </button>
                ))}
              </div>

              {tab === 'workflows' ? <AutomationsWorkspace projectId={projectId} /> : null}
              {tab === 'agents' ? <AgentsPanel projectId={projectId} /> : null}
              {tab === 'reports' ? <AutomationReportsPanel projectId={projectId} /> : null}
              {tab === 'policies' ? <EnrollPoliciesPanel projectId={projectId} /> : null}
            </>
          )}
        </div>
      </AutomationsFlagGate>
    </ProjectGate>
  );
}
